import { render, staticRenderFns } from "./FavoriteSelectorButtonParts.vue?vue&type=template&id=30f825c0&scoped=true"
import script from "./FavoriteSelectorButtonParts.vue?vue&type=script&lang=ts"
export * from "./FavoriteSelectorButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./FavoriteSelectorButtonParts.vue?vue&type=style&index=0&id=30f825c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f825c0",
  null
  
)

export default component.exports